.block {
  margin-bottom: 24px;
}

.countBadge {
  margin-left: 12px;
}

.batchBar {
  margin-top: 16px;
}

.context {
  max-width: 200px;
  margin: 0;
}

.wordTag {
  font-size: 14px;
}
